<template>
  <div class="base-layout-container" :class="{ 'full-width': fullWidth }">
    <div :class="['content-wrapper']">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLayout',
  props: {
    disableCard: {
      type: Boolean,
      default: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.base-layout-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 3rem;
  padding: 1rem;
  padding-bottom: 3rem;

  .content-wrapper {
    width: 100%;
    
    &.content-box {
      border-radius: 5px;
      background-color: #ffffff;
      box-shadow: -5px 10px 20px 3px rgba(0, 0, 0, 0.06);
      padding: 2rem;
      overflow: visible;
    }
  }

  :deep(.section-template) {
    margin-left: 0;
    margin-right: 0;
  }

  &.full-width {
    max-width: 100%;
    padding: 0.5rem;
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
    
    .content-wrapper.content-box {
      padding: 1rem;
    }
  }
}
</style>
